module.exports = __webpack_public_path__ + "static/media/frontline-4-keyword.470aaa6d.png";